import React from 'react';
import './index.less';
import Api from './api.js';
import {autobind} from 'core-decorators';
import { TopNavPage, NavUtils } from 'mutants-mobile-navigator';
import tools from '../../utils/tools';
import Ticon from '../Icon';


const preventEvent = (event) => {
  if (event) {
      event.preventDefault();
      event.stopImmediatePropagation && event.stopImmediatePropagation();
      event.stopPropagation();
  }
};

export default class RefTreeComponet extends React.Component {
  navLeftClick =()=> {
    this.props.navLeftClick && this.props.navLeftClick();
  }

  navRightContent() {
    return (
      <div className='navRight'>
        <div onClick={this.packUp}>收起</div>
      </div>
    )
  }

  packUp = () =>{
    this.clearSelectedNode();
  }

  navTitle() {
    return '选择' + '' + '分类';
  }

  constructor(props) {
    super(props);
    this.state = {
      data:[]
    }
    this.shouldUpdate = false;
  }



  getClassInfoOnline = async() =>{
    let cacheUtil = tools.cache();
    let dtoName = this.props.dtoName
    let request;
    switch (dtoName) {
      case 'InventoryDTO': request = Api.GetInventoryClass; break;
      case 'PartnerDTO': request = Api.GetPartnerClass; break;
    }
    if(!request){
      return;
    }
    let PartnerClass = await request.call(Api, false);
    PartnerClass = this.dealLevelData(PartnerClass);

    cacheUtil.setLocalStorage(`${dtoName}_${window.localStorage.orgId}_ClassInfo`,JSON.stringify(PartnerClass));
    const now = new Date();
    cacheUtil.setLocalStorage(`${dtoName}_${window.localStorage.orgId}_ClassInfoUpdateTime`, now.getTime())

    return PartnerClass;
  }

  async componentDidMount() {
    let cacheUtil = tools.cache();
    let dtoName = this.props.dtoName;
    let cachInvClassInfo = cacheUtil.getLocalStorage(`${dtoName}_${window.localStorage.orgId}_ClassInfo`);
    const updateTime = cacheUtil.getLocalStorage(`${dtoName}_${window.localStorage.orgId}_ClassInfoUpdateTime`);
    const now = new Date();
    if (cachInvClassInfo && updateTime) {
      cachInvClassInfo = JSON.parse(cachInvClassInfo);
      const expirationTime = 1 * 60 * 60 * 1000; // 1小时的毫秒数
      if (now - updateTime > expirationTime) {
        // 缓存过期，删除缓存
        cacheUtil.clear(`${dtoName}_${window.localStorage.orgId}_ClassInfo`);
        cacheUtil.clear(`${dtoName}_${window.localStorage.orgId}_ClassInfoUpdateTime`);
        cachInvClassInfo = null;
      }
    }

    if(!cachInvClassInfo){
      cachInvClassInfo = await this.getClassInfoOnline();
    }

    if(cachInvClassInfo){
      this.setState({
        data: cachInvClassInfo
      })
    }
  }

  _getStyles() {
    return {
      progressState: {
          position: 'absolute',
          left: '0',
          top: '0',
          right: '0',
          bottom: '0',
      }
    }
  }

  renderLeaf(item, level, leafMap) {
      level++;
      let hasLeaf = false, leafCount = 0;
      if(leafMap[item.ID] !== undefined && leafMap[item.ID].length > 0) {
          hasLeaf = true;
          leafCount = leafMap[item.ID].length;
           //console.log('level ' + level + ', child: ' + leafCount);
          var leafs = leafMap[item.ID].map(item => {
              //递归渲染下级节点
              return this.renderLeaf(item, level, leafMap);
          });
      } else {
         //console.log('level: ' + level + ', no child');
      }

      var rootLevel = 'root root_' + level;
      if(hasLeaf) {
          //根节点展开
          if(item.Open) {
              rootLevel += ' active';
              return (<li className="tree-li">
                          <div className={rootLevel}>
                               <div onClick={this.onOpenClick.bind(this, item)} key={item.ID} className="leaf-left">
                                  {leafCount && <Ticon type='shouqitubiao1' className='openicon'></Ticon>}
                                  <span className="chanjet-icon-unfold" style={{fontSize:'20px'}}></span>
                                  <p className='itemName'>{item.Name}<span>({leafCount})</span></p>
                              </div>
                          </div>
                          {leafs}
                      </li>);
          } else {
            rootLevel = 'root root_' + level;
            //根节点折叠
              return (<li className="tree-li">
                          <div className={rootLevel}>
                              <div onClick={this.onOpenClick.bind(this, item)} key={item.ID} className="leaf-left">
                                  {leafCount && <Ticon type='zhankaitubiao1' className='openicon'></Ticon>}
                                  <span className="chanjet-icon-fold" style={{fontSize:'20px'}}></span>
                                  <p className='itemName'>{item.Name}<span>({leafCount})</span></p>
                              </div>
                          </div>
                      </li>);
          }

      } else {
          return (<li className="tree-li" onClick = {this.onLeafClick.bind(this, item)} key={item.ID}>
                        <div className={rootLevel}>
                            <div className="leaf leaf-left">
                              <div className='namebox'>
                                {item.Name}
                              </div>
                            </div>
                        </div>
                  </li>);
      }
  }

  //处理分级数据 针对type = tree
  dealLevelData(data) {
    var rootList = [];//一级节点
    var rootMap = {};
    var leafMap = {};

    rootList.push({ID: "",Name: "全部" ,Open: false ,ParentID: "" ,label: "全部" ,value: ""})

    const expendNodes = tools.getCache('selectNodes',this.props.dtoName)

    data.forEach((item, index) => {

        item.Open = false;
        if(expendNodes && expendNodes.indexOf(item.ID)>-1){
          item.Open = true;
        }
        //label,value与enum的参数统一
        item.label = item.Name;
        item.value = item.ID;
        rootMap[item.ID] = item;
        if (item.ParentID === '') {
            rootList.push(item);
        } else {
            if(leafMap[item.ParentID]) {
                leafMap[item.ParentID].push(item);
            } else {
                leafMap[item.ParentID] = [];
                leafMap[item.ParentID].push(item);
            }
        }
    });
    var result = {};
    result.rootList = rootList;
    result.rootMap = rootMap;
    result.leafMap = leafMap;
    return result;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.shouldUpdate){
      this.shouldUpdate = false;
      return true;
    }
    nextState = nextState || {};
    nextProps = nextProps || {};
    if(this.state.data.length == nextState.data.length
       && this.props.isFixedClassify == nextState.isFixedClassify
        && (this.props.classifyItem && this.props.classifyItem.ID == nextProps.classifyItem.ID)){
      return false;
    }
    return true;
  }

  toSettingPage() {
    NavUtils.pushForResult('/settinglist', {fromPage: 'inventory'}, this.props.chooseCallback)
  }


  render(){
      let classifyItem = this.props.classifyItem || {ID: '1', Name: '一级'};
      let isFixedClassify = this.props.isFixedClassify || 'false';
      const styles = this._getStyles();
      
      if(!this.state.data || !this.state.data.rootList){
        return null;
      }
      let list = this.state.data.rootList.map(item => {
        return this.renderLeaf(item, 0 ,this.state.data.leafMap);
      });
      let dtoName = this.props.dtoName
      const {hideReviseBtn = false,showSetBtn = true}  = this.props;
      let titleText = isFixedClassify == 'false' ? '去设置' : '去修改'
      return(
          <div className='treeBox'>
            {dtoName == 'InventoryDTO' && !hideReviseBtn && <div className='tip'>
              {isFixedClassify == 'false' ? <p>分类可设置固定在商品参照左侧</p> : 
              <div className='fixedTitle'>
                <Ticon type='guding' style={{color: '#2fcd89'}}></Ticon>
                {/* <img src={fixed}/> */}
                <p>已固定{classifyItem && classifyItem.Name}分类</p>
              </div>}
              {showSetBtn && <div className='reviseBtn' onClick={this.toSettingPage.bind(this)}>{titleText}</div>}
            </div>}
            <ul className={`tree-ul ${dtoName == 'InventoryDTO'  && !hideReviseBtn ? 'specialTree' : ''}`}>
                {list}
            </ul>
            <div className='tree-footer'><p onClick={this.navLeftClick}>返回</p><p onClick={this.clearSelectedNode}>收起</p></div>
          </div>
      );
  }

  @autobind
  onLeafClick(env,event){
    preventEvent(event);
    this.props.groupCallBack&&this.props.groupCallBack(env.ID);
  }

  @autobind
  onOpenClick(env) {
      this.shouldUpdate = true;
      env.Open = !env.Open;
      this.saveSelectedNode();
      this.setState({
        data :  this.state.data
      })
  }

  clearSelectedNode = ()=>{
    for(let item in this.state.data.rootMap){
      this.state.data.rootMap[item].Open = false;
    }
    this.setState({
      data :  this.state.data
    })
    tools.putCache('selectNodes',this.props.dtoName,[])
  }

  saveSelectedNode = () =>{
    const expendNodes = [];
    for(let item in this.state.data.rootMap){
      if(this.state.data.rootMap[item].Open){
        expendNodes.push(this.state.data.rootMap[item].ID);
      }
    }
    tools.putCache('selectNodes',this.props.dtoName,expendNodes)
  }
  
}
